import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "output"];
  static values = { showIf: String };

  connect() {
    this.change();
  }

  change() {
    const value = this.inputTarget.value;

    this.outputTargets.forEach((output) => {
      const showIf = output.dataset.showIf || this.showIfValue || "";
      const visible = showIf.split(",").includes(value);
      output.hidden = !visible;

      output.querySelectorAll("input, select, textarea").forEach((field) => {
        field.disabled = !visible;
      });
    });
  }
}
